import React, { useEffect, useState } from 'react'
import { ArrowLeft, ArrowRight, ArrowUp, Navigation, Plus } from 'react-feather'
import { Link, useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from 'reactstrap'
import { fetch } from '../../../utility/helpers/Axios/fetch'
import Swal from "sweetalert2"
import { SwallTimer } from '../../../utility/helpers/SwalTimer'
import { ModalContext } from '../../components/contactform/ModalContext'
import { AddUserModal } from '../../components/modal/AddUserModal'

export const DomainForm = () => {

    const { id } = useParams()
    const [domain, setDomain] = useState({})
    const [statusModal, setStatusModal] = useState(false)

    const activeLicense = domain.licenses?.find(license => license.active)

    const loadDomain = async () => {
        const domain = await fetch('Domains', id)
        setDomain(domain)
    }

    const openModal = (e) => {
        e.preventDefault()
        console.log('Estas apunto de enviar un mensaje')
    }

    const upgradeUsersQty = () => {
        Swal.fire({
            html:
                '<h2 >Quiero solicitar un aumento de licencia.</h2>',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            width: 600,
            heightAuto: false,
            customClass: {
                actions: 'd-flex justify-content-space-between gap-4',
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-secondary'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                SwallTimer(4000)
                return await fetch("SendMailUpgradeClient", null, { contextData: { ...domain }, template: "upgradeUsers", to: 'mpalmucci@klinnic.com', subject: `Aumentar usuarios Klinnic` }, 'POST').then(async (res) => {
                    if (res.accepted.length > 0) {
                        return true
                    } else {
                        Swal.fire({
                            title: 'Error',
                            text: 'Ha habido algun problema',
                            icon: 'error'
                        })
                        return false
                    }
                })
            } else {
                Swal.fire({
                    title: 'Cancelado',
                    text: 'No se ha enviado ningun correo',
                    icon: 'error',
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                })
            }
        })
    }

    useEffect(() => {
        loadDomain()
    }, [])

    return (
        <div className='row'>
            <ModalContext.Provider value={{ statusModal, setStatusModal }} >
                <AddUserModal domain={domain} />
            </ModalContext.Provider>
            <div style={{ width: '70%' }} className="col-12">
                <Card className="p-2">
                    <CardHeader style={{ marginTop: '-25px', marginLeft: '-35px' }}>
                        <button className='btn btn-sm btn-danger ml-1' onClick={() => { history.back() }}><ArrowLeft size={15} /></button>
                    </CardHeader>
                    <CardBody className="row">

                        <div className='col-12 col-md-12 col-lg-2  mb-1 text-center'>
                            <h4 className='text-primary '>Dominio</h4>
                            <h5>
                                {domain.domainName}
                            </h5>
                        </div>
                        <div className='col-12 col-lg-2 mb-1 text-center'>
                            <h4 className='text-primary'>
                                Tipo de licencia
                            </h4>
                            <h5>
                                {
                                    activeLicense?.type === 0 ?
                                        <span>Estandar</span> : activeLicense?.type === 1 ?
                                            <span>Multi-centro</span> :
                                            <span></span>
                                }
                            </h5>
                        </div>
                        <div className='col-12 col-lg-2 mb-1 text-center'>
                            <h4 className='text-primary'>
                                Proxima renovación
                            </h4>
                            <h5>
                                {
                                    activeLicense?.expDate
                                }
                            </h5>
                        </div>
                        <div className='col-12 col-lg-2 mb-1 text-center'>
                            <h4 className='text-primary'>
                                Usuarios
                            </h4>
                            <h5>{domain.subscribers?.length} <a onClick={upgradeUsersQty}><button className='btn btn-sm btn-success ml-1'><ArrowUp size={15} /></button></a></h5>
                        </div>
                        {/* <div className='col-12 col-lg-2 mb-1 text-center'>
                            <h6 className='text-primary'>
                                <a href={domain.url} target="_blank">{domain.url}</a>
                            </h6>
                            <h5><a style={{ color: '#5e5873' }} href={domain.url} target="_blank">Visitar <Navigation /></a></h5>
                        </div> */}
                        <div className='col-12 col-lg-2 mb-1 text-center'>
                            <h4 className='text-primary'>
                                Forma de pago
                            </h4>
                            <h5>
                                {
                                    activeLicense?.paymentType === 0 ?
                                        <span>Mensual</span> : activeLicense?.paymentType === 1 ?
                                            <span>Anual</span> :
                                            <span></span>
                                }
                            </h5>
                        </div>
                        <div className='col-12 col-lg-2 mb-1 text-center'>
                            <h4 className='text-primary'>
                                Precio
                            </h4>
                            <h5>
                                {
                                    activeLicense?.price
                                } €
                            </h5>
                        </div>
                    </CardBody>
                </Card>
            </div>
            <div style={{ width: '29%' }} className='col-12'>
                <Card className="p-2" >
                    <CardBody className="justify-content-around">
                        <div className='d-flex justify-content-between mb-1'>
                            <h3 className='text-primary'>Usuarios</h3>
                            {

                                (domain.subscribers?.length < (activeLicense?.userQty ? activeLicense?.userQty : 1)) ?
                                    <button className='btn btn-sm btn-success' onClick={(e) => { e.preventDefault(); setStatusModal(!statusModal) }}>Invitar </button> :
                                    <span />
                            }
                        </div>

                        <table className='table table-sm '>
                            <thead className='' >
                                <tr >
                                    <th style={{ backgroundColor: '#08249e', color: 'white' }}>Nombre</th>
                                    <th style={{ backgroundColor: '#08249e', color: 'white' }}>Correo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    domain.subscribers?.map(({ klinnicUser }) => (
                                        <tr className=' p-1 m-1' key={klinnicUser?.id}>
                                            <td> {klinnicUser?.fullName} </td>
                                            <td> {klinnicUser?.email}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </CardBody>
                </Card>
            </div>
        </div >
    )
}
